<!-- Container -->
<div class="container">

  <ul>
    <li class="help-ul">
      Once you complete a trip, select "Delivery" from the main menu to add fish tickets and other final data.
      <ul>
        <li>
          Many fields will be saved for future landings so you do not need to always re-enter
        </li>
        <li>
          For fish tickets, use the red plus button to add one or more tickets
        </li>
        <li class="img-to-text">
          Review the "Sets Included in the Delivery".
          All completed sets will be automatically added to this list, but you can review and either add/remove sets

          <div class="row">
            <!-- current_delivery.png -->
            <img [src]="getImgs[0]"
            class="help-img"
            (click)="showImage(getImgs[0])" />
          </div>
          
          <div class="row">
            <!-- view_delivery_1.png -->
            <img [src]="getImgs[1]"
              class="help-img"
              (click)="showImage(getImgs[1])" />

            <!-- view_delivery_2.png -->
            <img [src]="getImgs[2]"
              class="help-img"
              (click)="showImage(getImgs[2])" />
          </div>
          
        </li>
      </ul>
    </li>
  </ul>

</div>
